import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SurveyForm } from '../../../../../components/common/survey/form/SurveyForm';
import { SurveyInputHeader } from '../../../../../components/common/survey/inputs/SurveyInputHeader';
import { SurveyTextInput } from '../../../../../components/common/survey/inputs/SurveyTextInput';
import { useAppDispatch } from '../../../../../hooks/store/useStore';
import { userJoinSlice } from '../../../../../store/userJoinSlice';
import { JoinProcessPageWrapper } from '../JoinProcessPageWrapper';

export const JoinProcessCropNamePage = () => {
  const navigate = useNavigate();
  const [cropName, setCropName] = useState<string>();

  const dispatch = useAppDispatch();
  const userJoinActions = userJoinSlice.actions;

  return (
    <JoinProcessPageWrapper
      headerTitle={'재배중인 작물에 대해서\n조금만 더 알려주세요'}
      canConfirm
      confirmHandler={() => {
        if (cropName) {
          dispatch(userJoinActions.changeCropName(cropName));
        }
        navigate('/join-process/reason', { replace: true });
      }}
    >
      <SurveyForm>
        <SurveyInputHeader inputTitle={'재배 작물 입력'} isOptional />

        <SurveyTextInput
          inputValue={cropName ?? ''}
          placeholder={'예) 콩, 쌀 이모작'}
          onChange={(value: string | undefined) => setCropName(value)}
        />
      </SurveyForm>
    </JoinProcessPageWrapper>
  );
};
